import { AuthAssetSlot } from '@/features/auth/components/AuthAssetSlot'
import { cn } from '@/lib/utils'

const VALUE_PROPS = [
  {
    label: 'Complete desafios',
    asset: '/auth/placeholders/value-prop-challenges.svg',
    fallbackIcon: 'trophy'
  },
  {
    label: 'Ganhe recompensas',
    asset: '/auth/placeholders/value-prop-rewards.svg',
    fallbackIcon: 'gift'
  },
  {
    label: 'Suba no ranking',
    asset: '/auth/placeholders/value-prop-ranking.svg',
    fallbackIcon: 'podium-star'
  }
] as const

export function AuthValueProps() {
  return (
    <ul
      className="grid grid-cols-3 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
      aria-label="Benefícios da plataforma"
    >
      {VALUE_PROPS.map((item, index) => (
        <li
          key={item.label}
          className={cn(
            'flex min-h-[76px] flex-col items-center justify-center gap-1.5 px-1.5 py-3 text-center short:min-h-[60px] short:gap-1 short:py-2 sm:min-h-[84px]',
            index > 0 && 'border-l border-gray-200'
          )}
        >
          <AuthAssetSlot
            src={item.asset}
            fallbackIcon={item.fallbackIcon}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#F3EEFF] short:h-8 short:w-8"
            imageClassName="h-8 w-8 object-contain short:h-7 short:w-7"
          />
          <span // `text-2xs` é o piso de 12px em caixa mista (MASTER §3); os valores
            // arbitrários de 10 e 11px ficavam abaixo dele.
            className="text-2xs font-semibold leading-tight text-gray-700">
            {item.label}
          </span>
        </li>
      ))}
    </ul>
  )
}
